module.exports = __webpack_public_path__ + "static/media/tick_white.c2d4b44a.svg";